import { render, staticRenderFns } from "./CreateLinkWizardStepTwo.vue?vue&type=template&id=46c57d85&scoped=true&"
import script from "./CreateLinkWizardStepTwo.vue?vue&type=script&lang=js&"
export * from "./CreateLinkWizardStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./CreateLinkWizardStepTwo.vue?vue&type=style&index=0&id=46c57d85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c57d85",
  null
  
)

export default component.exports